import { ScrollArea } from "@/frontend/algolia/components/ui/ScrollArea";
import { Checkbox } from "./ui/Checkbox";
import { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { useRefinementList } from "react-instantsearch"

const transformPriceRangeItems = (items: RefinementListItem[]) => items.map(item => {
    const [min, max] = item.label.split(":");
    const label = `$${min} - $${max}`;

    return ({ ...item, label })
})

export default function RefinementList({ attribute, isSearchable = false, limit = 40 }: { attribute: string; isSearchable?: boolean; limit?: number }) {
    const transformItems = attribute === 'price_range' ? transformPriceRangeItems : undefined;

    const {
        items,
        hasExhaustiveItems,
        canToggleShowMore,
        isShowingMore,
        toggleShowMore,
        refine,
        searchForItems,
        isFromSearch,
    } = useRefinementList({ attribute, limit, showMoreLimit: 100, showMore: !isSearchable, transformItems })


    if (items.length === 0 && !isFromSearch) return <p>No refinements available</p>;

    return (
        <div className="accordion-content tw-w-full tw-h-max tw-flex tw-flex-col tw-gap-2 tw-py-1 tw-pr-[11px]">

            {isSearchable && !hasExhaustiveItems &&
                <input placeholder="Keywords" type="text" onChange={(e) => searchForItems(e.currentTarget.value)} className="tw-w-full tw-rounded-sm tw-border tw-border-light-orange tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-dark-green-90" />
            }

            <ScrollArea orientation="vertical" className="tw-relative" type="auto">
                <div className="tw-h-max tw-max-h-[180px]">
                    <ul>
                        {
                            items.map((item, index) => {
                                const id = `${attribute}-${index}`

                                return (
                                    <li key={id} className="tw-h-10 tw-flex tw-items-center tw-space-x-2">
                                        <Checkbox
                                            // @ts-ignore @TODO
                                            id={id}
                                            value={item.value}
                                            checked={item.isRefined}
                                            disabled={item.count === 0}
                                            onCheckedChange={() => refine(item.value)}
                                            className="tw-h-4 tw-w-4 tw-border-dark-green-100 tw-text-white checked:tw-bg-red-400"
                                        />

                                        <label className="tw-text-sm tw-font-light tw-text-gray-700 tw-cursor-pointer tw-select-none" htmlFor={id}>
                                            {item.label} <span className="tw-pl-1">({item.count})</span>
                                        </label>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </ScrollArea>

            {canToggleShowMore &&
                <button className="tw-border tw-border-solid tw-border-light-orange tw-rounded-full tw-p-2 hover:tw-font-semibold" onClick={() => { toggleShowMore() }}>
                    {isShowingMore ? "Show Less" : "Show More"}
                </button>
            }
        </div>
    )
}

